import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function AddGoalIcon() {
  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9999 24.6004C19.4064 24.6004 24.5999 19.4069 24.5999 13.0004C24.5999 6.59389 19.4064 1.40039 12.9999 1.40039C6.5934 1.40039 1.3999 6.59389 1.3999 13.0004C1.3999 19.4069 6.5934 24.6004 12.9999 24.6004ZM22.0999 13.0004C22.0999 18.0262 18.0257 22.1004 12.9999 22.1004C7.97411 22.1004 3.8999 18.0262 3.8999 13.0004C3.8999 7.9746 7.97411 3.90039 12.9999 3.90039C18.0257 3.90039 22.0999 7.9746 22.0999 13.0004ZM12.9999 19.8254C16.7692 19.8254 19.8249 16.7697 19.8249 13.0004C19.8249 9.23105 16.7692 6.17539 12.9999 6.17539C9.23056 6.17539 6.1749 9.23105 6.1749 13.0004C6.1749 16.7697 9.23056 19.8254 12.9999 19.8254Z"
        fill="url(#paint0_linear_goal)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_goal"
          x1="1.3999"
          y1="6.43172"
          x2="12.5678"
          y2="29.2511"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
